// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".molecule-specs-list{align-items:center;display:flex;flex-wrap:wrap;gap:1rem;justify-content:center;margin:0 auto 6rem;max-width:100%;width:100%}@media only screen and (max-width:1200px){.molecule-specs-list{max-width:90%}}@media only screen and (max-width:767px){.molecule-specs-list{gap:.5rem;margin:0 auto 1.5rem;max-width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
